<template>
  <el-container
    class="container"
    style="padding:0"
  >
    <!-- 侧边栏 -->
    <el-aside
      width="200px"
      style="background: rgb(246, 248, 251);height:100%"
    >
      <LeftBar
        :left-items="leftItems"
        :currentSelectLeftItemKey="currentSelectLeftItemKey"
        @selectChange="leftItemselectChange"
      />
    </el-aside>

    <el-aside
      :width="showShortcutBar?'72px':'15px'"
      style="height:100%;overflow: hidden;"
      :style="{background: showShortcutBar ? '#F7F9FC':'white'}"
    >
      <div style="display: flex;justify-content: end;margin-top: 1px;margin-bottom: 6px;">
        <img
          v-if="showShortcutBar"
          @click="showShortcutBar=false"
          style="cursor:pointer;"
          src="../../assets/img/arrow_left.png"
          width="15"
          height="15"
        >
        <img
          v-else
          @click="showShortcutBar=true"
          style="cursor:pointer;"
          src="../../assets/img/arrow_right.png"
          width="15"
          height="15"
        >
      </div>
      <CustomDrawer
        v-if="showShortcutBar"
        :selectShortcutIdProps="contentMap[currentSelectLeftItemKey].selectShortcutId"
        :shortcuts="contentMap[currentSelectLeftItemKey].shortcuts"
        @shourtcutSelectChange="shourtcutSelectChange"
      />
    </el-aside>

    <!-- 主要内容容器 -->
    <el-container
      style="position:relative;height:100%"
      v-if="contentMap[currentSelectLeftItemKey].selectShortcutId !== 'project_fill_in_pass_rate'"
    >
      <!-- 容器顶部筛选条件按钮 -->
      <el-header style="height: 60px;background: white;">
        <!--        {{currentSelectLeftItemKey==Object.keys(contentMap)[0]}}{{currentSelectLeftItemKey==Object.keys(contentMap)[1]}}-->
        <!--        <ShortcutTool style="overflow:scroll;" :selectShortcutIdProps="contentMap[currentSelectLeftItemKey].selectShortcutId" :shortcuts="contentMap[currentSelectLeftItemKey].shortcuts" @shourtcutSelectChange="shourtcutSelectChange"/>-->
        <div v-show="currentSelectLeftItemKey==Object.keys(contentMap)[0]">
          <CustomTool
            ref="customTool1"
            style="width:100%;"
            :defaultDateArea="getToolConfigValueFromContentMap.defaultDateArea"
            :column_mapper="column_mapper"
            :showTodoListBtns="true"
            :todoListInfo="{currentSelectLeftItemKey:currentSelectLeftItemKey,userDeptInfo:userDeptInfo}"
            :time-area-text="'客户确认报价日期'"
            :show-time-area="true"
            :show-time="false"
            :filterArchiveData="getToolConfigValueFromContentMap.filterArchiveData"
            @filters="filterContentChange"
            @export="exportTodoList"
          />
        </div>
        <div v-show="currentSelectLeftItemKey==Object.keys(contentMap)[1]">
          <CustomTool
            ref="customTool2"
            style="width:100%;"
            :defaultDateArea="getToolConfigValueFromContentMap.defaultDateArea"
            :column_mapper="column_mapper"
            :showTodoListBtns="true"
            :todoListInfo="{currentSelectLeftItemKey:currentSelectLeftItemKey,userDeptInfo:userDeptInfo}"
            :time-area-text="'客户确认报价日期'"
            :show-time-area="true"
            :show-time="false"
            :filterArchiveData="getToolConfigValueFromContentMap.filterArchiveData"
            @filters="filterContentChange"
            @export="exportTodoList"
          />
        </div>
      </el-header>
      <div style="height: 100%;padding:20px 0px;overflow: scroll;background:white;">
        <!--
        //列表相关
        @row-click 点击列表某个item事件
        project-list-dl 表格列表内容

        //列和表头相关
        @column-drop 表头拖动排序事件
        show-coloums-dl 显示的列（即表头显示的）
        column_mapper 所有的列枚举（包含未在表头显示的）

        //排序相关
        @sort-change 排序变化事件
        sort-column-name-dl 排序的名称
        sort-column-order-dl 排序的规则

        //页面控制相关
        @current-change  当前页改变事件
        totalnums-dl 总页数
        pagesize-dl 每页页数
        page-number-dl 当前页

        //表头固定
        fixed-columns
        -->
        <custom-table
          ref="mytable2"
          :table-id="3"
          @row-click="rowClick"
          :project-list-dl="tableData.projectList"
          :show-coloums-dl="tableData.showColoums"
          :column_mapper="tableData.column_mapper"
          @sort-change="sortChange"
          :sort-column-name-dl="tableData.sortColumnName"
          :sort-column-order-dl="tableData.sortColumnOrder"
          @current-change="currentChange"
          :totalnums-dl="tableData.totalnums"
          :pagesize-dl="tableData.pagesize"
          :page-number-dl="tableData.pageNumber"
          :fixed-columns="tableData.fixedList"
          :disableDrag="true"
          :sortable="true"
          :pagination="tableData.pagination"
          :is-loading-dl="tableData.detailLoading"
          :use-virtual="false"
          :row-hegit="0"
          :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
          :customColumnWidth="tableData.customColumnWidth"
          @unusualShow="unusualShow"
          :custom-tabel-height-offset="265"
        ></custom-table>
      </div>

    </el-container>
    <el-aside
      v-if="getToolConfigValueFromContentMap.filterContent.queryCond.length && contentMap[currentSelectLeftItemKey].selectShortcutId !== 'project_fill_in_pass_rate'"
      :width="showFilterBar?'123px':'15px'"
      style="height:100%;overflow: hidden;z-index: 1;"
      :style="{background: showFilterBar ? '#F7F9FC':'white'}"
    >
      <div style="display: flex;justify-content: start;margin-top: 1px;margin-bottom: 6px;">
        <img
          v-if="showFilterBar"
          @click="showFilterBar=false"
          style="cursor:pointer;"
          src="../../assets/img/arrow_right.png"
          width="15"
          height="15"
        >
        <img
          v-else
          @click="showFilterBar=true"
          style="cursor:pointer;"
          src="../../assets/img/arrow_left.png"
          width="15"
          height="15"
        >
      </div>
      <CustomFilterDrawer
        v-show="showFilterBar&&currentSelectLeftItemKey==Object.keys(contentMap)[0]"
        :column_mapper="column_mapper"
        :queryCond="contentMap[currentSelectLeftItemKey].toolConfig.filterContent.queryCond"
        @removeSelect="removeSelect"
      />
      <CustomFilterDrawer
        v-show="showFilterBar&&currentSelectLeftItemKey==Object.keys(contentMap)[1]"
        :column_mapper="column_mapper"
        :queryCond="contentMap[currentSelectLeftItemKey].toolConfig.filterContent.queryCond"
        @removeSelect="removeSelect"
      />

    </el-aside>
    <ProjectFillIn v-if="contentMap[currentSelectLeftItemKey].selectShortcutId === 'project_fill_in_pass_rate'" />
  </el-container>
</template>

<script>
import CustomTable from "@/component/CustomTable";
import ShortcutTool from "@/component/TodoList/topTool/ShortcutTool";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import CustomCard from "@/component/Performance/CustomCard";
import CustomDialog from "@/component/Performance/dialog/CustomDialog";
import LeftBar from "@/component/Bar/leftBar/LeftBar";
import CustomDrawer from "@/component/Bar/customDrawer/CustomDrawer";
import CustomFilterDrawer from "@/component/Bar/customFilterDrawer/CustomFilterDrawer";
import ProjectFillIn from "@/component/TodoList/projectFillIn";
import { exportTodoList, getTodoList, getTodoListCount, getUnusualList, userDept } from '../../api/api'
import { getMonthStartDate } from "@/utils/util";
export default {
  name: "TodoList",
  props: ["refreshId"],
  components: {
    CustomTable,
    ShortcutTool,
    CustomTool,
    CustomCard,
    CustomDialog,
    LeftBar,
    CustomDrawer,
    CustomFilterDrawer,
    ProjectFillIn
  },
  data () {
    return {
      showShortcutBar: true,
      showFilterBar: true,
      column_mapper: {
        "project:quotation_type": "计价类型:varchar",
        "project:business_type": "业务类型:varchar",
        "dept:responsible_p_dept": "部门:varchar",
        "dept:responsible_s_dept": "业务组:varchar",
        "dept:sales_s_dept": "销售组:varchar",
        "client:client_name": "客户:varchar",
        "member:account_manager": "客户经理:varchar",
        "member:project_manager": "项目经理:varchar",
      },

      tableData: {
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList: [],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination: true,
        customColumnWidth: {
          project_comment: 400
        },
        tableColumnCustomConfig: {//图表某些列定制化显示
          'project:project_id': {
            type: "popover",
            showRule: {
              key: "project:project_remark",
              value: "异常"
            },
            project_id: "",
            closeTime: 1,
            openTime: 0,
            forceClose: false,
            show: false,
            popoverDatas: []
          }
        }
      },
      leftItems: [
        {
          id: 0,
          name: "客户经理需关注",
          key: "member:account_manager"
        },
        {
          id: 1,
          name: "项目经理需关注",
          key: "member:project_manager"
        }
        // {
        //   id: 2,
        //   name: "订单填报合格率",
        //   key: "project:accurate"
        // }
      ],
      currentSelectLeftItemKey: "member:account_manager",

      contentMap: {
        "member:account_manager": {
          selectShortcutId: "accepted_invoice",
          shortcuts: [],
          toolConfig: {
            filterRequestData: {},
            filterContent: {
              queryCond: [],
              sortCond: {
                columnName: "",
                value: ""
              },
              timerange: {
                start: "",
                end: ""
              }
            },
            defaultDateArea: {
              defaultStart: "",
              defaultEnd: ""
            },
            filterArchiveData: {
              start_end_date_dynamic: [],
              queryCond: []
            }
          }
        },
        "member:project_manager": {
          selectShortcutId: "uncommitted",
          shortcuts: [],
          toolConfig: {
            filterRequestData: {},
            filterContent: {
              queryCond: [],
              sortCond: {
                columnName: "",
                value: ""
              },
              timerange: {
                start: "",
                end: ""
              }
            },
            defaultDateArea: {
              defaultStart: "",
              defaultEnd: ""
            },
            filterArchiveData: {
              start_end_date_dynamic: [],
              queryCond: []
            }
          }
        }
      },


      userDeptInfo: {},
      // filterRequestData:{},
      // filterContent:{
      //   queryCond: [],
      //   timerange:{
      //     start:"",
      //     end:""
      //   }
      // },
      // defaultDateArea:{
      //   defaultStart:"",
      //   defaultEnd:""
      // },
      // filterArchiveData:{
      //   start_end_date_dynamic:[],
      //   queryCond: []
      // },

      // showTimeArea:true
    }
  },
  async mounted () {
    window.vm4 = this
    this.refresh()
    this.getUserDept()
  },

  computed: {
    getToolConfigValueFromContentMap () {
      // console.log('currentSelectLeftItemKey',this.currentSelectLeftItemKey)
      return this.contentMap[this.currentSelectLeftItemKey].toolConfig
    },
  },

  watch: {
    refreshId (newVal) {
      // console.log('refreshId change,刷新todoList',newVal)
      this.refresh(false)
    },
  },

  methods: {
    async getUserDept () {
      let res = await userDept({})
      // console.log('getUserDept',res)
      if (res.respCode == "000000") {
        this.userDeptInfo = res.respData
      } else {
        this.$message.warning(res.respMsg)
      }
    },

    removeSelect (item) {
      if (Object.keys(this.contentMap)[0] == this.currentSelectLeftItemKey) {
        this.$refs.customTool1.removeSelect(item)
      } else if (Object.keys(this.contentMap)[1] == this.currentSelectLeftItemKey) {
        this.$refs.customTool2.removeSelect(item)
      }
    },
    filterContentChange (content) {
      // console.log('filterContentChange',content)
      Object.assign(this.getToolConfigValueFromContentMap.filterContent, content)
      this.refresh()
      // this.getPerformanceData()
    },

    sortChange (e) {
      // console.log('sortChange',e)

      if (e.order === null) {
        this.getToolConfigValueFromContentMap.filterContent.sortCond.columnName = ""
        this.getToolConfigValueFromContentMap.filterContent.sortCond.value = ""
      } else {
        this.getToolConfigValueFromContentMap.filterContent.sortCond.columnName = e.prop
        if (e.order === 'ascending') {
          this.getToolConfigValueFromContentMap.filterContent.sortCond.value = 'asc'
        } else {
          this.getToolConfigValueFromContentMap.filterContent.sortCond.value = 'desc'
        }
      }
      this.refresh()
    },

    async exportTodoList () {
      let param = {
        menu: "overview",
        ...this.getToolConfigValueFromContentMap.filterRequestData
      }
      // console.log('exportTodoList/param',param)
      let loadingInstance = this.$loading.service({ fullscreen: true, text: '请等待导出' });
      try {
        let { data } = await exportTodoList(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        let contents = this.flatShortCuts()
        let fileName = this.getToolConfigValueFromContentMap.filterRequestData.index + '-' + Y + M + D + H + m + s + ".xlsx"
        let finditem = contents.find(c => c.id == this.getToolConfigValueFromContentMap.filterRequestData.index)
        if (finditem) {
          fileName = finditem.title + '-' + Y + M + D + H + m + s + ".xlsx"
        }
        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }


      }

    },

    async unusualShow (project_id) {
      let res = await getUnusualList({ project_id: project_id })
      let resData = res.data

      if (resData.hasOwnProperty('respCode')) {
        if (resData.respCode == "000000") {
          this.tableData.tableColumnCustomConfig['project:project_id'].project_id = project_id
          this.tableData.tableColumnCustomConfig['project:project_id'].popoverDatas = resData.respData
        } else {
          // this.$message.warning(resData.respMsg)
        }
      } else {
        this.$message.error("数据有误")
      }
    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick (e) {
      // console.log('rowClick', e['project:project_name'])
      // this.$store.commit("setProjectId", e["project:project_id"]);
      // this.$store.commit("setProjectInfo", {
      //   projectId: e["project:project_id"],
      //   projectName: e["project:project_name"],
      //   accu: 0
      // })
      window.open('http://dao.szltech.com/dao/#/businessAssociation/order/orderDetail?id=' + e["project:project_id"], '_blank')
    },

    async currentChange (e) {
      // console.log('currentChange',e)
      this.tableData.pageNumber = e;
      this.refresh(false)
    },

    shourtcutSelectChange (key) {
      this.contentMap[this.currentSelectLeftItemKey].selectShortcutId = key
      this.refresh()
    },

    leftItemselectChange (key) {
      // console.log('左侧item切换',key)
      this.currentSelectLeftItemKey = key
      this.refresh()
    },


    async getTodoListCountData () {
      let res = await getTodoListCount({
        ...this.getToolConfigValueFromContentMap.filterContent
      })
      let resData = res.data.respData || []
      resData.forEach(item => {
        const key = item.id
        this.contentMap[key].shortcuts = item.children
      })
      // console.log('getTodoListCount',resData)
      let contents = this.flatShortCuts()
      // console.log('getTodoListCount/contents',contents)
      for (const content of contents) {
        if (resData.hasOwnProperty(content.id)) {
          content.count = resData[content.id]
        }
      }
    },

    flatShortCuts () {
      return Object.values(this.contentMap).map(m => m.shortcuts).reduce((a, b) => [...a, ...b], [])
    },

    getRequestKeyPageCount (key) {
      let cuts = this.flatShortCuts()
      let findcut = cuts.find(c => c.id == key)
      // console.log('findcut',findcut)
      if (findcut) {
        // console.log('findcut.count',findcut.count)
        return findcut.count
      } else {
        return 0
      }
    },

    async getTodoListData (resetPage = false) {
      //TODO:loading
      let requestKey = this.contentMap[this.currentSelectLeftItemKey].selectShortcutId
      if (resetPage) {
        this.tableData.pageNumber = 1
      }
      this.$nextTick(async () => {
        this.getToolConfigValueFromContentMap.filterRequestData = {
          index: requestKey,
          pagiInfo: {
            currentPage: this.tableData.pageNumber,
            pagesize: this.tableData.pagesize
          },
          ...this.getToolConfigValueFromContentMap.filterContent
        }
        let postData = this.getToolConfigValueFromContentMap.filterRequestData
        // console.log('getTodoListData/postData', postData)
        let res = await getTodoList(postData)
        let resData = res.data
        const { respData: { cols_mapper, data, columns_list } } = resData
        // console.log('getTodoListData返回结果', resData, requestKey,cols_mapper,data,columns_list)
        this.tableData.column_mapper = cols_mapper
        this.tableData.projectList = data
        this.tableData.totalnums = this.getRequestKeyPageCount(requestKey)
        this.tableData.showColoums = columns_list
        // console.log('this.tableData.showColoums',this.tableData.showColoums )


        this.$nextTick(() => {
          this.tableData.detailLoading = false
        })

      })

    },

    async refresh (resetPage = true) {
      this.tableData.detailLoading = true
      await this.getTodoListCountData()
      await this.getTodoListData(resetPage)
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height: 200px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

